<template>
  <div class="swatch-container">
    <el-row class="tcf-row swatch-row">
      <el-col :span="24" class="card swatch-card">
        <div class="card-body">
          <div class="swatch-filter">
            <el-select v-model="brand" size="small" :clearable="true" placeholder="品牌" @change="brandChange">
              <el-option
                v-for="item in brandOptions"
                :key="item.brand_id"
                :label="item.brand_name"
                :value="item.brand_id">
              </el-option>
            </el-select>
          </div>
          <div class="swatch-filter">
            <el-select v-model="series" size="small" :clearable="true" placeholder="系列" @change="seriesChange">
              <el-option
                v-for="item in seriesOptions"
                :key="item.series_id"
                :label="item.series_name"
                :value="item.series_id">
              </el-option>
            </el-select>
          </div>
<!--          <div class="swatch-filter">-->
<!--            <el-select v-model="style" size="small" :clearable="true" placeholder="风格" @change="styleChange">-->
<!--              <el-option-->
<!--                v-for="item in styleOptions"-->
<!--                :key="item.sid"-->
<!--                :label="item.name"-->
<!--                :value="item.sid">-->
<!--              </el-option>-->
<!--            </el-select>-->
<!--          </div>-->
          <!-- <div class="swatch-filter">
            <el-select v-model="tone" size="small" :clearable="true" placeholder="色调" @change="toneChange">
              <el-option
                v-for="item in toneOptions"
                :key="item.tid"
                :label="item.name"
                :value="item.tid">
                <span style="float: left">{{ item.name }}</span>
                <div class="swatch-tone" :style="'background-image: url('+item.imgurl+')'"></div>
              </el-option>
            </el-select>
          </div> -->
          <div class="search-mode">
            <input type="text" class="search-input" placeholder="关键字搜索" v-model="search" @keyup.enter="searchSwatch" />
            <el-button class="search-btn" icon="el-icon-search" @click="searchSwatch"/>
          </div>
          <div style="width:100%;margin-top: 50px;color:#F56C6C;font-size: 13px">
            <i class="el-icon-info"></i> 温馨提示：因每台电脑显示器的亮度、色温、对比度有所不同，可能出现色差，具体颜色请以实物色板为准。<br/>
          </div>
        </div>
      </el-col>
      <el-col :span="24" class="swatch-content">
        <div v-viewer="viewerOptions" class="images" :images="swatchData">
          <el-row class="swatch-list">
            <el-col :span="4" class="swatch-item" v-for="(value,index) in swatchData" :key="index">
              <div class="swatch">
                <div class="lessonplay" @click="imageView(index)"><svg-icon icon-class="zoom"/></div>
                <div class="swatch-img" ref="viewer">
                  <img class="img" :alt="value.remarks" :src="value.img_url">
                </div>
                <div class="swatch-info">
                  <div class="swatch-name">{{value.name}}</div>
                  <div class="swatch-desc">{{value.seriesname}}<span style="float: right">{{value.brandname}}</span></div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
<!--        使用element ui的图片预览功能
        <el-row class="swatch-list">
          <el-col :span="4" class="swatch-item" v-for="(hc,index) in swatchData">
            <div class="swatch">
              <div class="lessonplay" @click="showView(index)"><svg-icon icon-class="zoom"/></div>
              <div class="swatch-img">
                <el-image class="img" :src="hc.img_url"></el-image>
              </div>
              <div class="swatch-info">
                <div class="swatch-name">{{hc.name}}</div>
                <div class="swatch-desc">{{hc.seriesname}}<span style="float: right">{{hc.brandname}}</span></div>
              </div>
            </div>
          </el-col>
        </el-row>-->
        <div class="loading"  v-loading="loading" element-loading-background="rgba(0, 0, 0, 0)">
          <el-button v-if="!loading&&isHaveNextPage" @click="loadMore">加载更多 <i class="el-icon-arrow-down"/></el-button>
        </div>
      </el-col>
    </el-row>
<!--    element ui 图片预览展示
    <el-image-viewer
      v-if="showViewer"
      :on-close="closeViewer"
      :initialIndex="initialIndex"
      :url-list="imgViewUrl" />-->
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import { getStyleList } from '@/api/pub'
import { getColorList } from '@/api/pub'
import { getBrandSeriesList } from '@/api/pub'
import { getSeriesList } from '@/api/pub'
import { getColorBoardList } from '@/api/about/swatch'
import 'viewerjs/dist/viewer.css'
import { directive as viewer } from 'v-viewer'

export default {
  name: 'swatch',
  components: { ElImageViewer },
  computed: {
    user: getUser
  },
  directives: {
    viewer: viewer({
      debug: true
    })
  },
  data() {
    this.viewerOptions = {
      backdrop: true, // 是否启用播放模态背景[布尔值/字符串：默认true](不启用时，点击空白处不会退出播放，仅点击右上角关闭按钮才会退出播放)
      inline: false, // 启用inline模式[布尔值：默认false]
      button: true, // 显示右上角关闭按钮[布尔值：默认true]
      navbar: true, // 显示缩略图导航[布尔值/数字：默认true]
      title: [true, (image) => `${image.alt}`], // 显示当前图片的标题(显示alt属性或从URL解析出的图片名称)[布尔值/数字/方法/数组：默认true]
      toolbar: true, // 显示工具栏、自定义工具栏[布尔值/数字/对象：默认true]
      tooltip: true, // 显示缩放百分比[布尔值：默认true]
      movable: true, // 图片是否可移动[布尔值：默认true]
      zoomable: true, // 图片是否可缩放[布尔值：默认true]
      rotatable: true, // 图片是否可旋转[布尔值：默认true]
      scalable: false, // 图片是否可翻转[布尔值：默认true]
      transition: true, // 使用CSS3过渡[布尔值：默认true]
      fullscreen: true, // 播放时是否全屏[布尔值/全屏配置：默认true]
      keyboard: true, // 是否支持键盘[布尔值：默认true]
      url: 'src' // 播放时图片地址 URL 来源。[字符串/方法：默认src](如果是字符串，则应该是每个图像元素的属性之一。 如果是方法，则应该返回一个有效的图像URL)
    }
    return {
      showViewer: false, // 显示查看器
      imgViewUrl: [],
      initialIndex: 0,
      brandOptions: [],
      seriesOptions: [],
      styleOptions: [],
      toneOptions: [],
      loading: false,
      search: '',
      type: 1,
      brand: '',
      series: '',
      style: '',
      tone: '',
      swatchData: [],
      currentPage: 0,
      isHaveNextPage: true,
      alt: '1'
    }
  },
  created() {
    this.getData()
    this.getSelectData()
  },
  methods: {
    a(){
      return this.alt
    },
    getSelectData() {
      // getStyleList().then(response => {
      //   this.styleOptions = response.data
      // })
      getColorList().then(response => {
        this.toneOptions = response.data
      })
      getBrandSeriesList().then(response => {
        this.brandOptions = response.data
      })
      getSeriesList().then(response => {
        this.seriesOptions = response.data
      })
    },
    loadMore() {
      this.currentPage++
      this.getData()
    },
    getData() {
      this.loading = true
      const data = {
        page: this.currentPage,
        limit: 12,
        content: this.search,
        seriesid: this.series,
        brandid: this.brand,
        styleid: this.style,
        colorid: this.tone
      }
      getColorBoardList(data).then(response => {
        this.loading = false
        this.swatchData = this.swatchData.concat(response.data)
        this.isHaveNextPage = response.data.length >= 12
        for (const d of response.data) {
          this.imgViewUrl.push(d.img_url)
        }
      })
    },
    /*

     */
    showView(index) {
      this.initialIndex = index
      this.showViewer = true
    },
    imageView(index) {
      const viewer = this.$el.querySelector('.images').$viewer
      viewer.index = index
      viewer.show()
      // this.$refs.viewer.$viewer.show()
    },
    closeViewer() {
      this.showViewer = false
    },
    brandChange(val) {
      this.currentPage = 0
      this.brand = val
      this.swatchData = []
      this.imgViewUrl = []
      this.getData()
    },
    seriesChange(val) {
      this.series = val
      this.currentPage = 0
      this.swatchData = []
      this.imgViewUrl = []
      this.getData()
    },
    styleChange(val) {
      this.style = val
      this.currentPage = 0
      this.swatchData = []
      this.imgViewUrl = []
      this.getData()
    },
    toneChange(val) {
      this.tone = val
      this.currentPage = 0
      this.swatchData = []
      this.imgViewUrl = []
      this.getData()
    },
    searchSwatch() {
      this.currentPage = 0
      this.swatchData = []
      this.imgViewUrl = []
      this.getData()
    }
  }
}
</script>

<style lang="scss" scoped>
  .swatch-container {
    .swatch-row{
      padding:20px 10px;
      .swatch-card{
        padding: 0 10px;
      }
    }
    .search-mode{
      float: right;
      width: 300px;
      position: relative;
      padding-right: 20px;
      .search-input{
        background-color: #F2F6FC;
        border:0;
        height: 32px;
        line-height: 32px;
        border-radius: 4px;
        color: #606266;
        padding: 0 40px 0 15px;
        -webkit-appearance: none;
        font-size: 12px;
        width: 100%;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        outline: 0;
        &::-webkit-input-placeholder {
          color: #C0C4CC;
        }
        &::-ms-input-placeholder {
          color: #C0C4CC;
        }
      }
      .search-btn{
        position: absolute;
        right: 20px;
        height: 32px;
        width: 40px;
        line-height: 32px;
        top: 0;
        border: 0;
        background: transparent;
        text-align: center;
        padding: 0;
      }
    }
    .swatch-content{
      margin-top: 20px;
      .swatch-list{
        width: 100%;
        padding: 0;
        margin:0 0 0 -10px;
        position: relative;
        .swatch-item{
          padding-left: 20px;
          position: relative;
          .swatch{
            cursor: pointer;
            list-style: none;
            position: relative;
            width: 100%;
            background: #ffffff;
            position: relative;
            overflow: hidden;
            float: left;
            border-radius: 2px;
            -webkit-box-shadow: 4px 4px 40px rgba(0,0,0,0.05);
            box-shadow: 4px 4px 40px rgba(0,0,0,0.05);
            border-color: rgba(0,0,0,0.05);
            margin-bottom: 20px;
            .lessonplay{
              background: rgba(0,0,0,.4);
              width: 100%;
              height: 180px;
              position: absolute;
              left: 0;
              top: 0;
              opacity: 0;
              z-index: 2;
              text-align: center;
              transition: .2s;
              .svg-icon{
                width: 50px;
                height: 50px;
                margin-top: 65px;
                color:rgba(255,255,255,0.7);
              }
            }
            .swatch-img{
              width: 100%;
              height: 180px;
              overflow: hidden;
              display: flex;
              align-items: center;
              .img{
                width: 100%;
              }
            }
            .swatch-info{
              padding: 10px;
              width: 100%;
              position: relative;
              .swatch-name{
                width: 100%;
                font-size: 14px;
                font-weight: bold;
                color:#606266;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                line-height: 20px;
              }
              .swatch-desc{
                width: 100%;
                font-size: 12px;
                color:#999999;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                line-height: 20px;
              }
            }
            &:hover{
              .lessonplay{
                opacity: 1;
              }
              .swatch-info{
                .swatch-name{
                  color:#409EFF;
                }
              }
            }
          }
        }
      }
      .loading{
        width: 100%;
        height: 40px;
        text-align: center;
        line-height: 40px;
      }
    }
    .swatch-filter{
      position: relative;
      float: left;
      margin-right: 20px;
      .el-button-group{
        .el-button{
          width: 80px;
        }
      }
      .el-select{
        width: 140px;
      }
      &:last-child{
        margin-right: 0;
      }
    }
  }
</style>
